module.exports = __webpack_public_path__ + "img/Dantam Bridal 14b.9d309092.jpg";